import { QueryResult } from '@apollo/client'
import { GetRolesQuery, useGetRolesQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useProjectContext } from 'context/ProjectContext'

type GetRolesQueryResult = QueryResult<GetRolesQuery>
export type Role = GetRolesQuery['roles']['records'][0]

const { Provider, useContextFn } = createStrictContext<{
  records: Role[]
  refetch: GetRolesQueryResult['refetch']
  fetching: GetRolesQueryResult['loading']
}>('RolesTableContext')

export const useRolesTableContext = useContextFn

export const RolesTableProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const {
    data,
    refetch,
    loading: fetching,
  } = useGetRolesQuery({
    ...DefaultQueryHookOptions,
    variables: {
      roleListInput: {
        projectId: { equals: projectId },
      },
    },
  })
  return (
    <Provider
      value={{
        records: data?.roles?.records ?? [],
        refetch,
        fetching,
      }}
    >
      {children}
    </Provider>
  )
}
